// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.statisticsBlockWrapper__jFWmG {
  display: grid;
  grid-template-columns: 1fr 65px;
  background: var(--tables-primary-row-surface-default);
  border: 1px solid var(--header-stroke);
}
@media (max-width: 1024px) {
  .statisticsBlockWrapper__jFWmG {
    grid-template-columns: 1fr 45px;
  }
}

.statisticsBlock__TDsyg {
  width: 100%;
  min-height: 78px;
  display: flex;
  align-items: center;
  column-gap: 1px;
}
@media (max-width: 1024px) {
  .statisticsBlock__TDsyg {
    min-height: 52px;
  }
}

.statItem__mP0E7 {
  height: 100%;
  flex: 1 1 0;
  display: grid;
  grid-template-columns: 1fr 48px;
  column-gap: 5px;
  padding: 15px;
  border-right: 1px solid var(--tables-primary-row-stroke);
}
@media (max-width: 1200px) {
  .statItem__mP0E7 {
    grid-template-columns: 1fr 32px;
  }
}
@media (max-width: 1024px) {
  .statItem__mP0E7 {
    grid-template-columns: 1fr;
    padding: 8px;
  }
}

.statItemInfo__CEf5k {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  row-gap: 10px;
}
@media (max-width: 1200px) {
  .statItemInfo__CEf5k {
    font-size: 10px;
  }
}

.statItemText__wTnk1 {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
  color: var(--title-inputs-sections-title);
  font-size: 11px;
  font-style: normal;
  font-weight: 400;
  line-height: 14px;
  text-transform: uppercase;
}

.statItemQuantity__RGvUS {
  text-wrap: nowrap;
  color: var(--legend-for-header-text);
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: 120%;
  letter-spacing: 0.5px;
}
@media (max-width: 1200px) {
  .statItemQuantity__RGvUS {
    font-size: 11px;
    line-height: 13px;
  }
}

@media (max-width: 1200px) {
  .statItemIcon__AtV9L {
    width: 32px;
    height: 32px;
  }
}
@media (max-width: 1024px) {
  .statItemIcon__AtV9L {
    display: none;
  }
}

.skeletonTextClassName__rNnvA {
  max-width: 180px;
  height: 12px;
}

.statsIconWrapper__iWyHU {
  display: flex;
  justify-content: center;
  align-items: center;
}

.statsIcon__w5Z4r {
  cursor: pointer;
  transform: rotate(-90deg);
  outline: none;
}

.statisticsTooltip__YdglN {
  padding: 8px !important;
  opacity: 1 !important;
  filter: drop-shadow(0 0 1px rgba(12, 26, 75, 0.24));
  border-radius: 4px !important;
  text-align: left !important;
}`, "",{"version":3,"sources":["webpack://./../src/pages/ActionItems/components/StatisticsBlock/style.module.scss"],"names":[],"mappings":"AA0EA;EACE,aAAA;EACA,+BAAA;EACA,qDAAA;EACA,sCAAA;AAzEF;AA2EE;EANF;IAOI,+BAAA;EAxEF;AACF;;AA2EA;EACE,WAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,eAAA;AAxEF;AA0EE;EAPF;IAQI,gBAAA;EAvEF;AACF;;AA0EA;EACE,YAAA;EACA,WAAA;EACA,aAAA;EACA,+BAAA;EACA,eAAA;EACA,aAAA;EACA,wDAAA;AAvEF;AAyEE;EATF;IAUI,+BAAA;EAtEF;AACF;AAuEE;EAZF;IAaI,0BAAA;IACA,YAAA;EApEF;AACF;;AAuEA;EACE,aAAA;EACA,sBAAA;EACA,8BAAA;EACA,aAAA;AApEF;AAsEE;EANF;IAOI,eAAA;EAnEF;AACF;;AAsEA;EACE,gBAAA;EACA,uBAAA;EACA,oBAAA;EACA,qBAAA;EACA,aAAA;EACA,4BAAA;EACA,yCAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,yBAAA;AAnEF;;AAsEA;EACE,iBAAA;EACA,oCAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,qBAAA;AAnEF;AAqEE;EATF;IAUI,eAAA;IACA,iBAAA;EAlEF;AACF;;AAsEE;EADF;IAEI,WAAA;IACA,YAAA;EAlEF;AACF;AAoEE;EANF;IAOI,aAAA;EAjEF;AACF;;AAoEA;EACE,gBAAA;EACA,YAAA;AAjEF;;AAoEA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;AAjEF;;AAoEA;EACE,eAAA;EACA,yBAAA;EACA,aAAA;AAjEF;;AAoEA;EA9HE,uBAAA;EACA,qBAAA;EACA,mDAAA;EACA,6BAAA;EACA,2BAAA;AA8DF","sourcesContent":["%scrollbar-style {\n  scrollbar-color: rgba(0, 0, 0, 0.2) rgba(0, 0, 0, 0.05);\n  scrollbar-width: auto;\n\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n@mixin scrollBar {\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n\n@mixin ellipsis-text {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: pre-wrap;\n  word-wrap: break-word;\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n}\n\n@mixin tooltip {\n  padding: 8px !important;\n  opacity: 1 !important;\n  filter: drop-shadow(0 0 1px rgba(12, 26, 75, 0.24));\n  border-radius: 4px !important;\n  text-align: left !important;\n}\n\n@mixin modalTitle {\n  color: var(--header-title-main);\n  font-size: 18px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 20px;\n  text-transform: uppercase;\n}\n\n.statisticsBlockWrapper {\n  display: grid;\n  grid-template-columns: 1fr 65px;\n  background: var(--tables-primary-row-surface-default);\n  border: 1px solid var(--header-stroke);\n\n  @media (max-width: 1024px) {\n    grid-template-columns: 1fr 45px;\n  }\n}\n\n.statisticsBlock {\n  width: 100%;\n  min-height: 78px;\n  display: flex;\n  align-items: center;\n  column-gap: 1px;\n\n  @media (max-width: 1024px) {\n    min-height: 52px;\n  }\n}\n\n.statItem {\n  height: 100%;\n  flex: 1 1 0;\n  display: grid;\n  grid-template-columns: 1fr 48px;\n  column-gap: 5px;\n  padding: 15px;\n  border-right: 1px solid var(--tables-primary-row-stroke);\n\n  @media (max-width: 1200px) {\n    grid-template-columns: 1fr 32px;\n  }\n  @media (max-width: 1024px) {\n    grid-template-columns: 1fr;\n    padding: 8px;\n  }\n}\n\n.statItemInfo {\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  row-gap: 10px;\n\n  @media (max-width: 1200px) {\n    font-size: 10px;\n  }\n}\n\n.statItemText {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  line-clamp: 2;\n  -webkit-box-orient: vertical;\n  color: var(--title-inputs-sections-title);\n  font-size: 11px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 14px;\n  text-transform: uppercase;\n}\n\n.statItemQuantity {\n  text-wrap: nowrap;\n  color: var(--legend-for-header-text);\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: 120%;\n  letter-spacing: 0.5px;\n\n  @media (max-width: 1200px) {\n    font-size: 11px;\n    line-height: 13px;\n  }\n}\n\n.statItemIcon {\n  @media (max-width: 1200px) {\n    width: 32px;\n    height: 32px;\n  }\n\n  @media (max-width: 1024px) {\n    display: none;\n  }\n}\n\n.skeletonTextClassName {\n  max-width: 180px;\n  height: 12px;\n}\n\n.statsIconWrapper {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.statsIcon {\n  cursor: pointer;\n  transform: rotate(-90deg);\n  outline: none;\n}\n\n.statisticsTooltip {\n  @include tooltip;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"statisticsBlockWrapper": `statisticsBlockWrapper__jFWmG`,
	"statisticsBlock": `statisticsBlock__TDsyg`,
	"statItem": `statItem__mP0E7`,
	"statItemInfo": `statItemInfo__CEf5k`,
	"statItemText": `statItemText__wTnk1`,
	"statItemQuantity": `statItemQuantity__RGvUS`,
	"statItemIcon": `statItemIcon__AtV9L`,
	"skeletonTextClassName": `skeletonTextClassName__rNnvA`,
	"statsIconWrapper": `statsIconWrapper__iWyHU`,
	"statsIcon": `statsIcon__w5Z4r`,
	"statisticsTooltip": `statisticsTooltip__YdglN`
};
module.exports = ___CSS_LOADER_EXPORT___;
